import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate, updateTemplateDetail } from "../../../../utils/fileEmbedApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import CommonTemplate from "../../../../components/Apps/FileEmbed/Template/CommonTemplate";

//Import Tabs
import ContentTab from "../../../../components/Apps/FileEmbed/ContentTab";
import LayoutTab from "../../../../components/Apps/FileEmbed/LayoutTab";
import AppearanceTab from "../../../../components/Apps/FileEmbed/AppearanceTab";

export default function CreateFileEmbed() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("PDF_File_Temp");
    const [selectedLayout, setSelectedLayout] = useState("pdf_file_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("pdf-file.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled File Embed");
    const [isTemplateId, setTemplateId] = useState(null);
    const [newWidgetName, setNewWidgetName] = useState("");
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);
    
    const [fileEmbedTabData, setFileEmbedTabData] = useState({
        is_website_frontend: "",  
        layout_type: "",  
        widget_title: "",  
        is_show_file_icon: 0,  
        file_icon_type: "",  
        preview_image_width: 0,  
        is_show_download_link: 0,
        download_link_text: "",
        width: "",
        height_width_ratio: 5,
        widget_title_color: "",
        name_color: "",
        icon_color: "",
        download_link_color: "",
        background_color: "",
        file_background_color: "",
        name_size: "15px",
        download_size: "12px",
        custom_css: "",   
        custom_js: "",
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let preview_image_width = 0;
            let layout_type = "";
            let width = "";
            let download_link_text = "";
            let is_show_download_link = "";
            let widget_title = "";
            let is_show_file_icon = "";
            let file_icon_type = "";
            let widget_title_color = "";
            let name_color = "";
            let icon_color = "";
            let download_link_color = "";
            let background_color = "";
            let file_background_color = "";
        
            switch (activeTemplateSection) {
                case "PDF_File_Temp":
                    preview_image_width = 100;
                    layout_type = "file-viewer";
                    width = "700px";
                    download_link_text = "DOWNLOAD";
                    is_show_download_link = 1;
                    widget_title = "";
                    is_show_file_icon = 1;
                    file_icon_type = "icon-1";
                    widget_title_color = "#000";
                    name_color = "#000";
                    icon_color = "#de2b33";
                    download_link_color = "#1c91ff";
                    background_color = "";
                    file_background_color = "";
                    break;
                case "Word_Document_Temp":
                    preview_image_width = 100;
                    layout_type = "file-viewer";
                    width = "700px";
                    download_link_text = "DOWNLOAD";
                    is_show_download_link = 1;
                    widget_title = "";
                    is_show_file_icon = 1;
                    file_icon_type = "icon-2";
                    widget_title_color = "#fff";
                    name_color = "#000";
                    icon_color = "#2B569A";
                    download_link_color = "#1c91ff";
                    background_color = "";
                    file_background_color = "";
                    break;
                case "Excel_Table_Temp":
                    preview_image_width = 100;
                    layout_type = "file-viewer";
                    width = "700px";
                    download_link_text = "DOWNLOAD";
                    is_show_download_link = 1;
                    widget_title = "";
                    is_show_file_icon = 1;
                    file_icon_type = "icon-3";
                    widget_title_color = "#000";
                    name_color = "#000";
                    icon_color = "#0F7B10";
                    download_link_color = "#1c91ff";
                    background_color = "";
                    file_background_color = "";
                    break;
                case "PowerPoint_Presentation_Temp":
                    preview_image_width = 100;
                    layout_type = "file-viewer";
                    width = "700px";
                    download_link_text = "DOWNLOAD";
                    is_show_download_link = 1;
                    widget_title = "";
                    is_show_file_icon = 1;
                    file_icon_type = "icon-4";
                    widget_title_color = "#000";
                    name_color = "#000";
                    icon_color = "#D24624";
                    download_link_color = "#1c91ff";
                    background_color = "";
                    file_background_color = "";
                    break;
                case "Restaurant_Menu_Temp":
                    preview_image_width = 70;
                    layout_type = "grid";
                    width = "700px";
                    download_link_text = "See Menu";
                    is_show_download_link = 1;
                    widget_title = "Our Restaurant Menu";
                    is_show_file_icon = 1;
                    file_icon_type = "icon-4";
                    widget_title_color = "#000";
                    name_color = "#000";
                    icon_color = "#000";
                    download_link_color = "#1c91ff";
                    background_color = "rgb(250, 250, 250)";
                    file_background_color = "rgb(255, 255, 255)";
                    break;
                case "Product_Manuals_Temp":
                    preview_image_width = 100;
                    layout_type = "grid";
                    width = "800px";
                    download_link_text = "DOWNLOAD";
                    is_show_download_link = 1;
                    widget_title = "Select Manual By Product";
                    is_show_file_icon = 1;
                    file_icon_type = "icon-4";
                    widget_title_color = "#000";
                    name_color = "#000";
                    icon_color = "#000";
                    download_link_color = "#1c91ff";
                    background_color = "";
                    file_background_color = "";
                    break;
                default:
                    preview_image_width = 0;
                    layout_type = "";
                    width = "";
                    download_link_text = "";
                    is_show_download_link = "";
                    widget_title = "";
                    is_show_file_icon = 0;
                    file_icon_type = "";
                    widget_title_color = "";
                    name_color = "";
                    icon_color = "";
                    download_link_color = "";
                    background_color = "";
                    file_background_color = "";
            }
        
            // Update setFileEmbedTabData state with the data
            setFileEmbedTabData((prevData) => ({
                ...prevData,
                preview_image_width: preview_image_width,
                layout_type: layout_type,
                width: width,
                download_link_text: download_link_text,
                is_show_download_link: is_show_download_link,
                widget_title: widget_title,
                is_show_file_icon: is_show_file_icon,
                file_icon_type: file_icon_type,
                widget_title_color: widget_title_color,
                name_color: name_color,
                icon_color: icon_color,
                download_link_color: download_link_color,
                background_color: background_color,
                file_background_color: file_background_color,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateFileEmbedTabData = (key, value) => {
        setFileEmbedTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = async () => {
        setShowTemplateSelection(false);
        setIsSubmitting(false);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        } 

       //Call Api To Create Templates with dummy data first
        try {
            // Collect data from refs
            const settingsArray = Object.entries(fileEmbedTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                    name: widgetName,
                    template_name: activeTemplateSection,
                    template_image: selectedTemplateImage,
                    layout_name: selectedLayout,
                    layout_type: selectedLayout,
                    app_type: "File_Embed",
                    module_type: "File_Embed",
                    template_type: activeTemplateSection, 
                    settings: settingsArray,
            };
            //setTemplateId("e4f2c79d-82ae-4094-8f06-1dc9e68fd962"); 
            //Api Call
            let api_response = await submitTemplate(payload);

            //Check Responce
            if (api_response.status === true) { 
                // Save templateId after first creation
                if (api_response.data.template_id) {
                    setTemplateId(api_response.data.template_id); 
                }
                setIsSubmitting(false); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
  }; 

  const menuItems = [
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Layout", icon: "layout.png", label: "Layout" },
      { key: "Appearance", icon: "appearance.png", label: "Appearance" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
        setActiveTemplateSection(event.target.value);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            const template_image = selectedRadio.dataset.template_image;
            setSelectedLayout(layoutTypeValue);
            setSelectedTemplateImage(template_image);
        } else {
            alert('Please select a template');
        }
    };

    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            // Convert settings object back into an array of key-value pairs
            const updateSettingsArray = Object.entries(fileEmbedTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: updateSettingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success("Submitted Successfully.");
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/file-embed');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="File Embed" app_type="File_Embed" app_slug="file-embed"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="PDF_File_Temp" data-layout_type="pdf_file_layout" data-template_image="pdf-file.png" checked={activeTemplateSection === "PDF_File_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/file-embed/templates/pdf-file.png`} alt="pdf-file" />
                                    </div> 
                                    <div className="content_sub">PDF File</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Word_Document_Temp" data-layout_type="word_document_layout" data-template_image="word-document.png" checked={activeTemplateSection === "Word_Document_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/file-embed/templates/word-document.png`} alt="word-document" />
                                    </div> 
                                    <div className="content_sub">Word Document</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Excel_Table_Temp" data-layout_type="excel_table_layout" data-template_image="excel-table.png" checked={activeTemplateSection === "Excel_Table_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/file-embed/templates/excel-table.png`} alt="excel-table" />
                                    </div> 
                                    <div className="content_sub">Excel Table</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="PowerPoint_Presentation_Temp" data-layout_type="powerPoint_presentation_layout" data-template_image="powerPoint-presentation.png" checked={activeTemplateSection === "PowerPoint_Presentation_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/file-embed/templates/powerPoint-presentation.png`} alt="powerPoint-presentation" />
                                    </div> 
                                    <div className="content_sub">PowerPoint Presentation</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Restaurant_Menu_Temp" data-layout_type="restaurant_menu_layout" data-template_image="restaurant-menu.png" checked={activeTemplateSection === "Restaurant_Menu_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/file-embed/templates/restaurant-menu.png`} alt="restaurant-menu" />
                                    </div> 
                                    <div className="content_sub">Restaurant Menu</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Product_Manuals_Temp" data-layout_type="product_manuals_layout" data-template_image="product-manuals.png" checked={activeTemplateSection === "Product_Manuals_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/file-embed/templates/product-manuals.png`} alt="product-manuals" />
                                    </div> 
                                    <div className="content_sub">Product Manuals</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/file-embed/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab isTemplateId={isTemplateId} setTemplateId={setTemplateId} updateFileEmbedTabData={updateFileEmbedTabData} fileEmbedTabData={fileEmbedTabData} setRefreshWidgetList={setRefreshWidgetList} />
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab updateFileEmbedTabData={updateFileEmbedTabData} fileEmbedTabData={fileEmbedTabData} />
                            )}
                            {activeSection === "Appearance" && (
                              <AppearanceTab updateFileEmbedTabData={updateFileEmbedTabData} fileEmbedTabData={fileEmbedTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/file-embed"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/file-embed/file-embed.svg`} alt="file-embed"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/file-embed/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/file-embed" className="close-button">Close</Link></div> 
                    </div>
                    <div className="source-title-row">Pdf Embed <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Call Common template*/}
                    <CommonTemplate selectedTemplate={activeTemplateSection} isTemplateId={isTemplateId} fileEmbedTabData={fileEmbedTabData} refreshWidgetList={refreshWidgetList} />
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 